import { useState } from "react";
import PropTypes from "prop-types";

import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import { ArrowLeftSolidV6 } from "@shared/v2/Icomoon";
import VerifyAddressModalBody from "./VerifyAddressModalBody";

const VerifyAddressModal = ({ originalAddress, suggestedAddress, onClose, onSubmit, onEdit, show }) => {
  const [isSuggestedAddress, setIsSuggestedAddress] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const onCloseHandler = () => {
    setIsSuggestedAddress(true);
    setIsLoading(false);
    onClose();
  }

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      show={show}
      onHide={onCloseHandler}
      contentClassName="tw-w-[616px] tw-flex tw-flex-col tw-gap-24px"
    >
      <Modal.Header
        title="Verify Address Format"
        closeButton
      />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[16px] tw-p-8px">
        <VerifyAddressModalBody
          suggestedAddress={suggestedAddress}
          originalAddress={originalAddress}
          isSuggestedAddress={isSuggestedAddress}
          setIsSuggestedAddress={setIsSuggestedAddress}
        />
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between">
        <Button className='tw-flex tw-gap-6px tw-justify-center tw-items-center' schema="tertiary" size="medium" onClick={() => {
          onEdit()
          onCloseHandler()
        }}>
          <ArrowLeftSolidV6 />
          <span>Edit</span>
        </Button>
        <Button
          schema="primary" size="medium"
          isLoading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            await onSubmit(isSuggestedAddress ? suggestedAddress : originalAddress);
            setIsLoading(false);
            onCloseHandler();
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export default VerifyAddressModal;

VerifyAddressModal.propTypes = {
  originalAddress: PropTypes.shape({
    addressType: PropTypes.string,
    streetAddress: PropTypes.string,
    secondaryAddress: PropTypes.string,
    city: PropTypes.string,
    locality: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  suggestedAddress: PropTypes.shape({
    addressType: PropTypes.string,
    streetAddress: PropTypes.string,
    secondaryAddress: PropTypes.string,
    city: PropTypes.string,
    locality: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  show: PropTypes.bool
};

VerifyAddressModal.defaultProps = {
  show: false,
}
